var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box",attrs:{"id":"insights"}},[(!_vm.useAuthStore().isLoggedIn)?_c('account-verification-warning',{on:{"verify-account":function($event){return _vm.$root.go('v2.account.verify')}}}):_c('insights')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }